import "./App.css";
// import NavBar from "./components/NavBar";
import VideoList from "./components/VideoList";

function App() {
   
  return (
    <>
      <h1>Video Recommendation</h1>
      <VideoList />
    </>
  );
}

export default App;
